import React from 'react';

const Footer = () => {
    const year = new Date().getFullYear()
    return (
        <div
            className={'text-start border-top border-3 border-blue-100 p-2 small footer mt-auto py-1 bg-body-tertiary'}>
            <div>© {year} CollQB</div>
        </div>
    );
};

export default Footer;
